/**
 * Main chat component.
 */
(function () {
    'use strict';
    var ItxChatCmp = {
        controller: ItxChatCmpCtrl,
        templateUrl: 'chat.component.html'
    };

    ItxChatCmpCtrl.$inject = [
        '$q',
        'ItxChatSvc',
        '$rootScope',
        'ItxStaticResourceSvc',
        'UserService',
        'crmService',
        'ItxLoginSvc',
        'ItxScreenSizeSvc',
        'mdFeelSuscriptionService',
        'CommonServices',
        'mdFeelBenefitsService',
        'CmsConfigSvc',
        '$scope',
        'WidgetService',
        '$injector'
    ];

    function ItxChatCmpCtrl(
        $q,
        ItxChatSvc,
        $rootScope,
        ItxStaticResourceSvc,
        UserService,
        crmService,
        ItxLoginSvc,
        ItxScreenSizeSvc,
        mdFeelSuscriptionService,
        CommonServices,
        mdFeelBenefitsService,
        CmsConfigSvc,
        $scope,
        WidgetService,
        $injector
    ) {
        var _this = this;

        _this.buttonIcon = ItxStaticResourceSvc.getIcon('live-help.png');
        _this.liveHelpConfiguration = {};

        _this.$onInit = function () {
            _this.initChats();
            _this.showSelection = false;
            _this.isMobile = ItxScreenSizeSvc.is('xs,sm');
            WidgetService = $injector.get('WidgetService');
        };

        /**
         * Función para inicializar los chats
         */
        _this.initChats = function () {
            inditex.onReady(function () {
                // Obtenemos la configuración inicial de Hubtype, Url Chat y Kakao Talk
                _this.initHubtypeUrlChats();

                // Obtenemos la configuración inicial de Style Advisor (Solo Desktop)
                _this.initStyleAdvisor();

                // Si cambiamos la configuración de cookies, re-inicializamos Style Advisor (Solo Desktop)
                if (!CommonServices.isWebapp()) {
                    inditex.cookieConsent.addConsentChangedHandler(function (activeGroups) {
                        if (activeGroups && activeGroups['C0002'] && activeGroups['C0002'].allowed) {
                            _this.initStyleAdvisor();
                        }
                    });
                }
            });
        };

        _this.openSelection = function () {
            _this
                .initWhatsapp()
                .then(() => {
                    setTimeout(() => {
                        if (_this.enableDigitalChannels) {
                            _this.showSelection = !_this.showSelection;
                            if (_this.showSelection) {
                                $('#chatTextSelection').removeClass('is-active');
                            }
                        } else {
                            _this.showSelection = false;
                            _this.openLiveHelpWindow();
                        }
                        $scope.$digest();
                    });
                })
                .catch((e) => {
                    $('#chatTextSelection').removeClass('is-active');
                    _this.showSelection = false;
                    _this.enableDigitalChannels = false;
                    _this.openLiveHelpWindow();
                });
        };

        _this.initWhatsapp = function () {
            const mdFeelBenefitsConfig = mdFeelBenefitsService.getWhatsAppInfo();
            const cmsConfigByPage = CmsConfigSvc.getProperty('enable_digital_channels');
            return $q.all([cmsConfigByPage, mdFeelBenefitsConfig]).then(function (result) {
                let isWhatsApp = false;
                if (result[0]) {
                    const isPage = result[0].pages.find((page) => page === inditex.iPage);
                    const isLanguage = result[0].languages.find((language) => language === inditex.iLangId);
                    isWhatsApp = result[0].contact.find((contact) => contact === 'whatsapp');
                    _this.enableDigitalChannels = false;
                    if (isPage && isLanguage && result[0].active) {
                        _this.enableDigitalChannels = true;
                    }
                }
                if (result[1] && result[1].enabled) {
                    _this.seeWhatsapp = isWhatsApp;
                    _this.whatsappConfig = result[1];
                    if (!_this.isMobile) {
                        _this.whatsappUrl = result[1].link;
                    } else {
                        _this.whatsappUrl = 'https://wa.me/' + result[1].phoneNumber;
                    }
                }
            });
        };

        /**
         * Función para inicializar Hubtype, Url Chat y Kakao Talk
         */
        _this.initHubtypeUrlChats = function () {
            // Obtenemos la configuración inicial de Hubtype y UrlChat
            ItxChatSvc.initHubtypeUrlChats().then(function (hubtypeUrlConfiguration) {
                _this.liveHelpConfiguration.hubtype = hubtypeUrlConfiguration.hubtype;
                _this.liveHelpConfiguration.urlChat = hubtypeUrlConfiguration.urlChat;
                _this.liveHelpConfiguration.kakao = hubtypeUrlConfiguration.kakao;

                // Mostramos el botón de apertura solo en Web (Mantenemos oculto en webviews de apps)
                if (!CommonServices.isWebapp()) {
                    _this.showButton();
                }

                // Obligamos a cerrar Hybtype
                ItxChatSvc.closeHubtype();
            });
        };

        /**
         * Función para inicializar Style Advisor
         */
        _this.initStyleAdvisor = function () {
            // Mostramos Style Advisor en función de su configuración
            ItxChatSvc.initStyleAdvisor().then(function (styleAdvisorConfiguration) {
                _this.liveHelpConfiguration.styleAdvisor = styleAdvisorConfiguration;

                // Mostramos el botón de apertura solo en Web (Mantenemos oculto en webviews de apps)
                if (!CommonServices.isWebapp()) {
                    _this.showButton();
                }

                // Si habiamos intentado abrir Style Advisor con anterioridad, lo abrimos automaticamente
                if (inditex.getLocalStorage('openStyleAdvisorAttempt') && crmService.is360()) {
                    _this.showHideButton('hide');

                    setTimeout(function () {
                        ItxChatSvc.openStyleAdvisor();
                    }, 2000);
                }
            });
        };

        /**
         * Función para mostrar el botón de apertura
         */
        _this.showButton = function () {
            if (
                (_this.liveHelpConfiguration.hubtype && _this.liveHelpConfiguration.hubtype.active) ||
                (_this.liveHelpConfiguration.styleAdvisor && _this.liveHelpConfiguration.styleAdvisor.active) ||
                (_this.liveHelpConfiguration.urlChat && _this.liveHelpConfiguration.urlChat.active) ||
                (_this.liveHelpConfiguration.kakao && _this.liveHelpConfiguration.kakao.active)
            ) {
                _this.showHideButton('show');

                // Añadimos la clase para la animación (Solo para Desktop)
                if (ItxScreenSizeSvc.is('md,lg')) {
                    _this.animateButton();
                }
            }
        };

        /**
         * Función para abrir el selector de tipo de ayuda
         */
        _this.openLiveHelpWindow = function () {
            if (_this.enableDigitalChannels) {
                _this.showSelection = !_this.showSelection;
            }
            // Si Style Advisor está activo, mostraremos la ventana de preselección
            if (
                (_this.liveHelpConfiguration.styleAdvisor && _this.liveHelpConfiguration.styleAdvisor.active) ||
                (_this.liveHelpConfiguration.kakao && _this.liveHelpConfiguration.kakao.active)
            ) {
                _this.liveHelpConfiguration.showLiveHelpWindow = true;
                _this.showHideButton('show');
            } else {
                // En caso contrario, abriremos los chats directamente
                if (_this.liveHelpConfiguration.hubtype && _this.liveHelpConfiguration.hubtype.active) {
                    ItxChatSvc.openHubtype();
                } else if (_this.liveHelpConfiguration.urlChat && _this.liveHelpConfiguration.urlChat.active) {
                    ItxChatSvc.openUrlChat();
                }

                _this.showHideButton('hide');
            }
        };

        /**
         * Función para cerrar el selector de tipo de ayuda
         */
        _this.closeLiveHelpWindow = function () {
            _this.liveHelpConfiguration.showLiveHelpWindow = false;
            _this.showHideButton('show');
        };

        /**
         * Función para abrir Style Advisor
         */
        _this.openStyleAdvisor = function () {
            // Comprueba que el usuario esté autenticado
            if (UserService.isAuthenticated()) {
                // Abre el chat de Style Avisor solo en caso de que el usuario esté suscrito al programa Feel
                if (crmService.is360()) {
                    _this.liveHelpConfiguration.showLiveHelpWindow = false;
                    _this.showHideButton('hide');

                    ItxChatSvc.openStyleAdvisor();
                } else {
                    mdFeelSuscriptionService.openCrmPopup();

                    _this.liveHelpConfiguration.showLiveHelpWindow = false;
                    _this.showHideButton('show');
                }
            } else {
                // Añadimos en local storage un control para especificar que hemos intentado abrir Style Advisor (solo para Desktop)
                if (ItxScreenSizeSvc.is('md,lg')) {
                    inditex.setLocalStorage('openStyleAdvisorAttempt', true);
                }

                ItxLoginSvc.popupSignIn();

                _this.liveHelpConfiguration.showLiveHelpWindow = false;
                _this.showHideButton('show');
            }
        };

        /**
         * Función para abrir Hubtype
         */
        _this.openHubtype = function () {
            _this.liveHelpConfiguration.showLiveHelpWindow = false;
            _this.showHideButton('hide');

            ItxChatSvc.openHubtype();
        };

        _this.openKakaoChat = function () {
            _this.liveHelpConfiguration.showLiveHelpWindow = false;
            _this.showHideButton('hide');

            ItxChatSvc.openKakaoChat();
        };

        /**
         * Función para abrir Url Chat
         */
        _this.openUrlChat = function () {
            _this.liveHelpConfiguration.showLiveHelpWindow = false;
            _this.showHideButton('hide');

            ItxChatSvc.openUrlChat();
        };

        /**
         * Funciónes a ejecutar cuando nos autenticamos
         */
        $rootScope.$on('login:success', function () {
            // Reinicializamos los chats dado que habrán cambiado las condiciones para mostrarse
            _this.initChats();
        });

        /**
         * Actualiza la visualización del componente
         */
        $rootScope.$on('changeChatVisualizations', function (event, data) {
            // Aplicamos lógica de visualización u ocultación de botones solo para Desktop
            if (!CommonServices.isWebapp()) {
                switch (data.event) {
                    case 'showButton':
                        _this.showHideButton('show');
                        break;
                    case 'hideButton':
                        _this.showHideButton('hide');
                        break;
                }
            }
        });

        /**
         * Función para añadir las clases para mostrar u ocultar el boton
         */
        _this.showHideButton = function (status) {
            if (status === 'hide') {
                $('.live-help-button-wrapper').addClass('closed');
                $('.live-help-button-wrapper').removeClass('open');
            } else if (status === 'show') {
                $('.live-help-button-wrapper').addClass('open');
                $('.live-help-button-wrapper').removeClass('closed');
            }
        };

        /**
         * Función para aplicar las animaciones al botón flotante
         */
        _this.animateButton = function () {
            // Añade la animación
            setTimeout(function () {
                $('#chatTextSelection').addClass('is-active');
                $('.closeSelection').removeClass('is-active');
            }, 2000);

            // Quita la animación
            setTimeout(function () {
                $('#chatTextSelection').removeClass('is-active');
            }, 8000);
        };
    }

    angular.module('itxApp.common').component('mdChats', ItxChatCmp);
})();
